// extracted by mini-css-extract-plugin
module.exports = {"divider":"_3eddD","dropdownDeleteIcon":"_1KHzA","presetsWrapper":"_3UaXI","addPresetContainer":"_1kTEX"};